/* eslint-disable */

// Dev Requests chain-scoped constants. Colors warmed to the New DNA palette
// (2026-07-08 Phase-2 redesign). Labels/keys + all logic below are unchanged.
export const DR_STATUS = {
  pending:  { label: 'PENDING',  color: '#a86810', bg: '#fef6ea', border: '#fcd29f' },
  accepted: { label: 'ACCEPTED', color: '#3f72a4', bg: '#eef4fb', border: '#d3e2f2' },
  rejected: { label: 'DECLINED', color: '#c0503f', bg: '#fdf3f1', border: '#f0d5cf' },
};

export const DR_PRIORITY = {
  low:    { label: 'LOW',    color: '#8e887b' },
  normal: { label: 'NORMAL', color: '#3f72a4' },
  high:   { label: 'HIGH',   color: '#a86810' },
  urgent: { label: 'URGENT', color: '#c0503f' },
};

export const DR_TYPE_COLORS = {
  DA: '#c2410c', DS: '#0369a1', DO: '#059669', CL: '#7c3aed',
};

// "In development" (timeline / linked banner) semantic green.
export const DR_INDEV = { color: '#3a8845', bg: '#edf6ef', border: '#cfe6d5' };

export function getMeta(request) {
  return request?.messages?.[0]?._meta || {};
}

export function canSeeRequest(request, myDesignerNames = [], role) {
  if (role === 'admin') return true;
  return (request.assigned_to || []).some(name =>
    myDesignerNames.some(dn => dn.toLowerCase() === name.toLowerCase())
  );
}

export function groupRequests(requests) {
  return {
    pending:  requests.filter(r => r.status === 'pending'),
    accepted: requests.filter(r => r.status === 'accepted'),
    rejected: requests.filter(r => r.status === 'rejected'),
  };
}

export function fmtDRDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${d.getDate()}/${months[d.getMonth()]}/${String(d.getFullYear()).slice(2)}`;
}
